<template>
    <button type="button" class="button small c-nav-button" v-on:click.prevent="openSupportReveal()" v-html="translate('frontend.js.global.button_support')"></button>
</template>
<script>
    export default {
        name: 'support-button',
        methods: {
            openSupportReveal() {
                // Check if gtag is set before tracking
                if( window.gtag ) {
                    // Measure Google Analytics Event before redirect to next page
                    gtag('event', 'generate_lead', {
                        'event_category': 'engagement',
                        'event_label': 'Open offerteformulier',
                        'transport_type': 'beacon'
                    });
                }

                this.$emit('openSupportReveal');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/support/support-button.vue